import React, { useEffect, useState } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { RiSettings4Line } from "react-icons/ri";
import { useAPI } from "../Context/MyContext";

const ConnectWA = () => {
  const { getPhoneAll } = useAPI();
  const [whatsappProfiles, setWhatsappProfiles] = useState([]);

  useEffect(() => {
    const fetchPhones = async () => {
      try {
        const res = await getPhoneAll();
        // console.log("Fetched WhatsApp data:", res);
        setWhatsappProfiles(res?.data || []);
      } catch (err) {
        console.error("Failed to fetch phones:", err);
      }
    };

    fetchPhones();
  }, []);

  return (
    <div className="px-4 py-12 sm:px-8 md:px-16 lg:px-32 bg-gray-50 min-h-screen">
      {/* Main Section */}
      <div className="bg-white rounded-2xl shadow-sm p-10 max-w-5xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800">
            Connect WhatsApp Business{" "}
            <span className="text-green-600 font-semibold">(Recommended)</span>
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            One Click Business Integration
          </p>
        </div>

        <div className="mt-8 text-center">
          <button className="bg-green-500 hover:bg-green-600 text-white flex items-center gap-2 mx-auto py-3 px-8 rounded-full text-lg font-semibold shadow-md transition duration-300">
            <FaWhatsapp size={24} />
            Connect WhatsApp
          </button>
        </div>

        <ul className="mt-8 text-sm text-gray-700 list-disc pl-6 space-y-3">
          <li>
            The seamless integration will open in a pop-up. Make sure your
            browser is not blocking pop-ups.
          </li>
          <li>
            You will be asked to provide a phone number for WhatsApp Business
            integration. We strongly recommend using a new phone number.
          </li>
          <li>
            If you already have a WhatsApp account associated with that number,
            back up your WhatsApp data and then delete that account.
          </li>
        </ul>
      </div>

      {/* Bottom Section - Render Multiple Business Info Cards */}
      <div className="mt-12 max-w-7xl mx-auto grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        {whatsappProfiles.map((profile, index) => (
          <div key={index} className="bg-white rounded-2xl shadow-sm p-8">
            {/* Header */}
            <div className="flex items-center justify-between mb-4 text-sm text-gray-700">
              <div className="font-semibold text-lg text-gray-800">
                {profile.verified_name || "Unnamed Business"}
              </div>
              <div className="text-xs text-gray-500">
                Business Account ID: {profile.business_id}
              </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-2 mb-6">
              <button className="bg-green-100 hover:bg-green-200 text-green-700 text-sm font-semibold py-1.5 px-4 rounded shadow">
                Disable
              </button>
              <button className="bg-gray-100 hover:bg-gray-200 text-gray-800 text-sm font-semibold py-1.5 px-4 rounded shadow flex items-center gap-1">
                <RiSettings4Line size={16} />
                Manage
              </button>
            </div>

            {/* Profile Info */}
            <div className="border rounded-xl p-6 bg-gray-50 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-xl">
                  <FaWhatsapp />
                </div>
                <div>
                  <div className="font-semibold text-lg text-gray-800">
                    {profile.verified_name}
                  </div>
                  <div className="text-sm text-gray-500">Profile Settings</div>
                </div>
              </div>

              <div className="mt-4 space-y-2 text-sm text-gray-700">
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <FaPhoneAlt /> Number:{" "}
                    <span className="font-medium">{profile.display_phone_number}</span>
                  </span>
                </div>
                <div>
                  Number ID: <span className="font-medium">{profile.id}</span>
                </div>
                {/* <div>
                  Quality:{" "}
                  <span className="text-green-600 font-semibold">-</span>
                </div> */}
                <div>
                  Status:{" "}
                  <span className="text-gray-800">
                    {profile.code_verification_status}
                  </span>
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6">
                <button className="bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-6 rounded-md font-semibold shadow">
                  Register
                </button>
                <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm py-2 px-6 rounded-md font-semibold shadow">
                  Disconnect
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectWA;
